import { createAction, props } from '@ngrx/store';

export const loadAccountsPermissions = createAction('[Dashboard] Load Accounts Permissions', props<{ payload: any }>());
export const loadAccountsPermissionsSuccess = createAction('[Dashboard] Load Accounts Permissions Success', props<{ payload: any }>());
export const loadAccountsPermissionsFail = createAction('[Dashboard] Load Accounts Permissions Fail', props<{ payload: any }>());

export const loadUnitsPermissions = createAction('[Dashboard] Load Units Permissions', props<{ payload: any }>());
export const loadUnitsPermissionsSuccess = createAction('[Dashboard] Load Units Permissions Success', props<{ payload: any }>());
export const loadUnitsPermissionsFail = createAction('[Dashboard] Load Units Permissions Fail', props<{ payload: any }>());
